<template>
  <div class="transparent-tab">
    <div class="transparent-tab-btn-left" v-if="!visible">
      <a-button shape="round" icon="caret-left" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent-tab-btn-right" v-else>
      <a-button shape="round" icon="caret-right" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent-tab-wrapper" v-show="visible">
      <div class="m-panel-body">
        <div class="fixed">
          <!-- <div class="header-order">序号</div> -->
          <!-- <div class="header-item">项目编号</div> -->
          <div class="header-order">{{ $t('节点编号') }}</div>
          <div class="header-item">{{ $t('节点类型') }}</div>
          <div class="header-item">{{ $t('告警类型') }}</div>
          <div class="header-item">{{ $t('告警时间') }}</div>
        </div>
        <div style="overflow: hidden; height: calc(100% - 40px)">
          <vue-seamless-scroll :data="list" class="seamless-warp" ref="seamlessScroll" :class-option="classOption">
            <ul class="list-ul">
              <li class="list-row" v-for="(item, index) in list" :key="index">
                <!-- <div class="list-order">
                  <div class="order">{{ index + 1 }}</div>
                </div> -->
                <!-- <div class="list-item" :title="item.projectCode">{{ item.projectCode }}</div> -->
                <div class="list-order" :title="item.nodeCode">
                  <div class="order">{{ item.nodeCode }}</div>
                </div>
                <div class="list-item" :title="item.nodeType">{{ item.nodeType }}</div>
                <div class="list-item" :title="item.warningType">{{ item.warningType }}</div>
                <div class="list-item" :title="item.warningTime">{{ item.warningTime }}</div>
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: 'modal',
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      title: this.$t('组件1'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {
        list: '/jeecg-gis/warning/list',
      },
      activeKey: '1',
      list: [],
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  methods: {
    getData() {
      getAction(this.url.list, { pageSize: 999 }).then(res => {
        if (res.success) {
          this.list = res.result.records.concat(res.result.records.concat(res.result.records))
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleOpenOrClose() {
      this.visible = !this.visible
      this.$emit('change');
      if (this.visible) {
        this.getData()
      }
    },
  },
}
</script>
<style lang="less" scoped>
.transparent-tab {
  width: 100%;
  position: absolute;
  top: 0;
}
.transparent-tab-wrapper {
  width: 420px;
  height: 300px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
  padding: 10px;
  overflow: hidden;
}
.transparent-tab-btn-left {
  position: absolute;
  top: 120px;
  right: -24px;
  bottom: 0;
  z-index: 999;
  text-align: center;
  transform: rotate(90deg);
  ::v-deep .anticon {
    transform: rotate(-90deg);
  }
}
.transparent-tab-btn-right {
  position: absolute;
  right: 415px;
  top: 120px;
  z-index: 999;
  text-align: center;
  transform: rotate(90deg);
  ::v-deep .anticon {
    transform: rotate(-90deg);
  }
}
::v-deep .ant-tabs-bar {
  margin: 0;
}
::v-deep .ant-tabs-nav-container {
  color: #fff;
  background: rgba(70, 76, 92, 0.8);
  margin-top: 0;
  border-radius: 6px 6px 0 0;
  .ant-tabs-nav {
    width: 100%;
    div {
      display: flex;
      .ant-tabs-tab {
        flex: 1;
        justify-content: center;
      }
    }
  }
}
::v-deep .ant-tabs-tabpane {
  padding: 10px;
}
.m-panel-body {
  height: 100%;
}
.fixed {
  display: flex;
  align-items: center;
  background-color: rgba(70, 76, 92, 0.8);
  color: #fff;
  height: 30px;

  .header-item {
    width: 28.33%;
    text-align: center;
  }

  .header-order {
    width: 15%;
    text-align: center;
  }
}
.list-ul {
  padding-left: 0;
}
.list-row {
  color: rgba(70, 76, 92, 0.8);
  display: flex;
  height: 33px;
  align-items: center;
  line-height: 35px;
  border: 1px solid rgba(70, 76, 92, 0.8);
  border-bottom-width: 0;
  &:last-child {
    border-bottom-width: 1px;
  }

  .order {
    width: 48px;
    height: 18px;
    border-radius: 2px;
    text-align: center;
    line-height: 18px;
    color: #fff;
  }
}

.list-row .list-item {
  width: 28.33%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  color: #fff;
}

.list-order {
  width: 15%;
  display: flex;
  justify-content: center;
}
// .custom-tabs {
//   width: 220px !important;
// }

/* 覆盖Ant Design默认样式 */
// ::v-deep .ant-tabs-nav {
//   margin: 0 !important;
//   padding: 0 6px;
// }

// ::v-deep .ant-tabs-tab {
//   padding: 4px 10px !important;
//   background: transparent !important;
//   border: none !important;
//   border-radius: 4px !important;
//   margin-right: 2px;
//   transition: all 0.2s ease;
// }

// ::v-deep .ant-tabs-tab:hover {
//   background: rgba(0, 0, 0, 0.04) !important;
// }

// ::v-deep .ant-tabs-tab-active {
//   color: #1890ff !important;
//   font-weight: 500;
//   box-shadow: 0 1px 3px rgba(24, 144, 255, 0.2);
// }

// ::v-deep .ant-tabs-ink-bar {
//   display: none !important;
// }

// .tab-content {
//   padding: 12px;
//   background: white;
//   border-radius: 4px;
//   margin-top: 6px;
// }
::v-deep .ant-btn-primary{
  background-color: rgba(70, 76, 92, 0.8);
  border-color: rgba(70, 76, 92, 0.8);
}
</style>
